<template>
    <modal :id="id" :loading="loading" :saveing="saveing" @shown="shown" @ok="save" @cancel="cancel">
        <span slot="modal-title">使用者</span>
        <div class="row">
            <div class="col-md-4 col-sm-12">
                <form-input v-model="vm.Account" id="Account" label="帳號" type="text" required></form-input>
            </div>
            <div class="col-md-4 col-sm-12">
                <form-input v-model="vm.Password" id="Password" label="密碼" type="password"></form-input>
            </div>
            <div class="col-md-4 col-sm-12">
                <label>啟用</label>
                <label class="form-control">
                    <input type="checkbox" v-model="vm.Enabled" value="true" />
                </label>
            </div>
            <div class="col-12">
                <div class="form-group">
                    <label>群組</label>
                    <label class="form-control" v-for="item in groups" :key="item.key">
                        <input type="checkbox" v-model="vm.Group" :value="item.key" />{{item.value}}
                    </label>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
    import { detail } from '@/views';
    export default detail({
        name: 'memberDetail',
        api: '/api/member/',
        data: { groups: [] },
        vm: { Group: [] },
        created: function () {
            window.menu = [];
            this.$parameter.group().then((res) => { this.groups = res.data; });
        },
        methods: {
            add: function () { }
        },
    });
</script>

<style>
</style>